import searchIcon from '@jetbrains/icons/search.svg'
import type {ContainerProps, InputSpecificProps} from '@jetbrains/ring-ui/components/input/input'
import Input, {Size} from '@jetbrains/ring-ui/components/input/input'
import classNames from 'classnames'
import {useRef} from 'react'

import useEventCallback from '../../../hooks/useEventCallback'
import {useSearchShortcut} from '../../packages/Shortcuts/hooks/useSearchShortcut'
import type {GlobalSearchKind} from '../../packages/Shortcuts/Shortcuts.types'
import HelpLink from '../HelpLink/HelpLink'
import IconButton from '../IconButton/IconButton'

import styles from './SearchInput.css'

type Props = ContainerProps<InputSpecificProps> & {
  helpUrl?: string | null | undefined
  size?: Size
  searchKind?: GlobalSearchKind
}
function SearchInput(props: Props) {
  const {className, searchKind, helpUrl, size = Size.FULL, icon = searchIcon, ...restProps} = props
  const classes = classNames(styles.container, className)
  const inputRef = useRef<HTMLInputElement>(null)
  const searchShortcutParametersHandler = useEventCallback(() => {
    inputRef.current?.focus()
    inputRef.current?.select()
  })

  useSearchShortcut(searchShortcutParametersHandler, searchKind)

  return (
    <div className={classes}>
      <Input
        data-test={`runner-item-filter`}
        inputClassName={styles.input}
        size={size}
        icon={icon}
        type="search"
        inputRef={inputRef}
        {...restProps}
      />
      {helpUrl != null && <HelpLink url={helpUrl} Component={IconButton} icon="help" />}
    </div>
  )
}
export default SearchInput
